
const FEDEX_FIELDS = [
  'accountNumber',
  'key',
  'secretKey',
  'batchShipping',
  'meter',
  'mode',
  'smartPost',
  'trackingApiKeys',
];
const UPS_FIELDS = [
  'accountNumber',
  'key',
  'password',
  'batchShipping',
  'mode',
];

const getCarrierFields = (carrierType, fieldName) => {
  if (!carrierType) return false;

  if (carrierType.toLowerCase() === 'fedex') return FEDEX_FIELDS.includes(fieldName);
  if (carrierType.toLowerCase() === 'ups') return UPS_FIELDS.includes(fieldName);

  return false;
};

export default getCarrierFields;
